import type { MeResponse } from '@stalvi/contracts';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { Logo } from './Logo';
import { SearchBackendToggle } from './SearchBackendToggle';

export function Header({ me, onSignOut }: { me: MeResponse; onSignOut: () => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onDocClick(e: MouseEvent) {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const initial = (me.email[0] ?? '?').toUpperCase();

  return (
    <header className="app-header">
      <Link to="/" className="block" aria-label="Catálogo Stalvi — ir al inicio">
        <Logo />
      </Link>
      <nav className="flex items-center gap-4 text-sm">
        <Link to="/groups" className="text-text-secondary hover:text-text-primary">
          Grupos
        </Link>
        <SearchBackendToggle />
      </nav>
      <div ref={ref} className="relative">
        <button
          type="button"
          className="user-avatar"
          aria-label="Menú de usuario"
          aria-haspopup="menu"
          aria-expanded={open}
          onClick={() => setOpen((x) => !x)}
        >
          {initial}
        </button>
        {open && (
          <div
            role="menu"
            className="absolute right-0 mt-2 min-w-[220px] rounded-md border border-border-default bg-bg-card shadow-lg p-1"
          >
            <div className="px-3 py-2 text-sm text-text-secondary truncate" aria-disabled="true">
              {me.email}
            </div>
            <button
              type="button"
              role="menuitem"
              className="block w-full text-left px-3 py-2 text-sm rounded hover:bg-bg-subtle"
              onClick={() => {
                setOpen(false);
                onSignOut();
              }}
            >
              Cerrar sesión
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
